import Icon from 'veui/components/Icon'

Icon.register({
  'chevron-right': {
    paths: [
      {
        d: 'M34.17 24L13.6 3.41A2 2 0 0116.4.6l22 22a2 2 0 010 2.82l-22 22a2 2 0 11-2.82-2.82L34.17 24z'
      }
    ],
    width: '48',
    height: '48'
  }
})
